import { render, staticRenderFns } from "./TarjetaForm.vue?vue&type=template&id=13e14042"
import script from "./TarjetaForm.vue?vue&type=script&lang=js"
export * from "./TarjetaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports